import React from "react"
import { ButtonLoadingSeeker } from "@ui-seeker/core"

import { useUserSettingsAcriss, useUserSettingsAcrissValidator } from "../../../@hooks"


export default function UserSettingAcrissDrawerSubmit() {
	const { isLoading, handleSubmitAcrissFormData } = useUserSettingsAcriss()
	const { isValid } = useUserSettingsAcrissValidator()

	return <ButtonLoadingSeeker
		loading={isLoading}
		disabled={!isValid}
		onClick={handleSubmitAcrissFormData}
	>
		Save
	</ButtonLoadingSeeker>
}